define('viewmodels/modals/dialogs/ChangeEmailDialog',['knockout'], function (ko) {

    var ChangeEmailDialog = function (
        dialog,
        formFields,
        settingsModel,
        errorAlert,
        wpChangeEmailModal,
        sessionHistory
    ) {
        var self = this;

        self.dialog = dialog;

        self.translations = {
            headerTitle: wpChangeEmailModal('dialog_title'),
            confirm: wpChangeEmailModal('confirm_button'),
            label: {
                email: wpChangeEmailModal('enter_email'),
                password: wpChangeEmailModal('confirm_with_password')
            },
            messages: {
                wrongPassword: wpChangeEmailModal('wrong_password')
            }
        };

        self.valid = ko.observable(true);

        self.emailField = formFields.emailField(settingsModel.email);
        self.passwordField = formFields.passwordField(settingsModel.plaintextPassword);

        self.command = settingsModel.createChangeMailCommand(
            function () {
                self.resetFormData();
                self.close();
            },
            function () {
                self.valid(false);
            }
        );

        settingsModel.player().contactInfo.email.subscribe(function (email) {
            var player = settingsModel.player();

            sessionHistory.saveSessionHistory({
                casumoName: player.adventurer.casumoName(),
                email: email,
                name: ko.toJS(player.contactInfo.name)
            });
        })
    };

    ChangeEmailDialog.prototype.close = function () {
        this.resetFormData();
        this.dialog.close (this);
    };

    ChangeEmailDialog.prototype.resetFormData = function () {
        this.passwordField.value('');
        this.emailField.value('');
        this.valid(true);
    };

    return ChangeEmailDialog;
});

